/**
 * How the board shows priority and labels. One source, so the legend on the
 * board and the dots on the cards can never disagree.
 */

import type { LabelColor, Priority } from "./types";

export const PRIORITY_DOT: Record<Priority, { dot: string; label: string }> = {
  high: { dot: "bg-bad", label: "High" },
  med:  { dot: "bg-warn", label: "Medium" },
  low:  { dot: "bg-gray2/50", label: "Low" },
};

/** Cards in a done column wear this instead of their priority. */
export const DONE_DOT = { dot: "bg-teal", label: "Done" };

export const LEGEND = [PRIORITY_DOT.high, PRIORITY_DOT.med, PRIORITY_DOT.low, DONE_DOT];

export const LABEL_COLORS: LabelColor[] = ["gray", "teal", "green", "amber", "red", "blue", "purple", "pink"];

export const LABEL_CHIP: Record<LabelColor, string> = {
  gray:   "bg-line text-charcoal",
  teal:   "bg-teal-mint text-teal-dark",
  green:  "bg-ok-bg text-ok",
  amber:  "bg-warn-bg text-warn",
  red:    "bg-bad-bg text-bad",
  blue:   "bg-sky-100 text-sky-800",
  purple: "bg-violet-100 text-violet-800",
  pink:   "bg-pink-100 text-pink-800",
};

/** "just now", "5m ago", "3h ago", "2d ago", "6w ago". */
export function updatedAgo(iso: string, now: Date = new Date()): string {
  const s = Math.max(0, (now.getTime() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 86400 * 14) return `${Math.floor(s / 86400)}d ago`;
  return `${Math.floor(s / (86400 * 7))}w ago`;
}
